import { ComponentType, FC } from 'react'
import { useGlobalRedirects } from './useGlobalRedirects'
import PageWrapper from '../PageWrapper/PageWrapper'
import { SuperLoading } from '../Loading/SuperLoading'

export const WithGlobalRedirects = <P extends object>(
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ComponentToValidate: ComponentType<P>,
  { isPublic }: { isPublic: boolean }
): FC<P> => {
  const WithGlobalRedirectsComponent = (componentProps: P): JSX.Element => {
    const { loading } = useGlobalRedirects({ isPublic })

    if (loading) {
      return (
        <PageWrapper>
          <SuperLoading />
        </PageWrapper>
      )
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ComponentToValidate {...(componentProps as P)} />
  }

  return WithGlobalRedirectsComponent
}
